import { Label } from '@/common/ui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'
import { OtpEnabled } from './components/OtpEnabled'
import { RegisterEnabled } from './components/RegisterEnabled'
import { SkipBankEnabled } from './components/SkipBankEnabled'
import { UniqueBankNameEnabled } from './components/UniqueBankNameEnabled'
import { InitTypeComponent } from './components/InitType'
import { DisplayAllPromotionEnabled } from './components/DisplayAllPromotionEnabled'
import { HideClearTurnoverButton } from './components/HideClearTurnoverButton'
import { EnableMaskPhone } from './components/EnableMaskPhone'
import { SendDepositLineFlexMessage } from './components/SendDepositLineFlexMessage'
import { SendWithdrawLineFlexMessage } from './components/SendWithdrawLineFlexMessage'
import { MaxLoginAttempts } from './components/MaxLoginAttempts'

interface GeneralSettingBoxProps {
	data: GetGeneralSettingResponse
}

export default function GeneralSettingBox({ data }: GeneralSettingBoxProps) {
	return (
		<div className="space-y-4 sm:space-y-6">
			<Card>
				<CardHeader className="pb-4 sm:pb-6">
					<CardTitle className="text-lg sm:text-xl">ตั้งค่าทั่วไป</CardTitle>
				</CardHeader>
				<CardContent className="space-y-4 sm:space-y-6">
					{/* Toggle Settings - Mobile Responsive */}
					<div className="space-y-3 sm:space-y-4">
						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">เปิดใช้งาน OTP</Label>
							</div>
							<OtpEnabled data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									เปิดให้สมัครสมาชิก
								</Label>
							</div>
							<RegisterEnabled data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									อนุญาตให้ข้ามกรอกบัญชีธนาคารตอนสมัคร
								</Label>
								<p className="text-xs text-muted-foreground">
									เมื่อเปิดใช้งาน ผู้เล่นสามารถกด &quot;ข้ามขั้นตอนนี้&quot;
									ที่หน้ากรอกบัญชีธนาคารได้ และต้องกรอกบัญชีก่อนฝาก/ถอนครั้งแรก
								</p>
							</div>
							<SkipBankEnabled data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									ห้ามชื้อธนาคารซ้ำ
								</Label>
							</div>
							<UniqueBankNameEnabled data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									จำกัดจำนวนครั้งการล็อกอินผิด
								</Label>
								<p className="text-xs text-muted-foreground">
									เมื่อเปิดใช้งาน
									ระบบจะบล็อคการล็อกอินหากพยายามล็อกอินผิดเกินจำนวนครั้งที่กำหนด
								</p>
							</div>
							<MaxLoginAttempts data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									ซ่อนเบอร์โทรศัพท์
								</Label>
								<p className="text-xs text-muted-foreground">
									เมื่อเปิดใช้งาน เบอร์โทรศัพท์จะถูกซ่อนในหน้า Admin
								</p>
							</div>
							<EnableMaskPhone data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									แสดงโปรโมชั่นทั้งหมด (ปิด = โชว์เฉพาะโปรโมชั่นที่ลูกค้าใช้ได้)
								</Label>
							</div>
							<DisplayAllPromotionEnabled data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									ปิดการโชว์ปุ่มล้างเทิร์น
								</Label>
							</div>
							<HideClearTurnoverButton data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									เปิดเกมด้วยโหมด (Iframe / External)
								</Label>
							</div>
							<InitTypeComponent data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									ส่ง LINE Flex Message เมื่อฝากเงินสำเร็จ
								</Label>
							</div>
							<SendDepositLineFlexMessage data={data} />
						</div>

						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									ส่ง LINE Flex Message เมื่อถอนเงินสำเร็จ
								</Label>
							</div>
							<SendWithdrawLineFlexMessage data={data} />
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	)
}
